import { c as _c } from "react/compiler-runtime";
import { FaqContentProps } from "@/types";
export function FaqContent(t0) {
  const $ = _c(14);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h3 className="text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-3">Basics</h3>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="space-y-1.5 bg-muted/50 p-3.5 rounded-2xl"><h4 className="font-medium text-[15px]">How do I create a new todo?</h4><p className="text-sm text-muted-foreground">Type your todo in the input field at the bottom and press Enter. You can also use voice input by clicking the microphone icon.</p></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="space-y-1.5 bg-muted/50 p-3.5 rounded-2xl"><h4 className="font-medium text-[15px]">How do I edit a task?</h4><p className="text-sm text-muted-foreground">Hover over any task and click the pencil icon that appears to edit it.</p></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="space-y-1.5 bg-muted/50 p-3.5 rounded-2xl"><h4 className="font-medium text-[15px]">What happens to completed tasks?</h4><p className="text-sm text-muted-foreground">They remain in your list but are marked as complete. You can clear all completed tasks from the list menu.</p></div>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h4 className="font-medium text-[15px]">Where can I find the source code?</h4>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div>{t1}<div className="space-y-4">{t2}{t3}{t4}<div className="space-y-1.5 bg-muted/50 p-3.5 rounded-2xl">{t5}<p className="text-sm text-muted-foreground">Vif is an open source project. You can find the source code on{" "}<a href="https://github.com/zaidmukaddam/vif" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">GitHub</a>.</p></div></div></div>;
    t7 = <h3 className="text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-3">Features</h3>;
    $[5] = t6;
    $[6] = t7;
  } else {
    t6 = $[5];
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="space-y-1.5 bg-muted/50 p-3.5 rounded-2xl"><h4 className="font-medium text-[15px]">Can I add emojis to my todos?</h4><p className="text-sm text-muted-foreground">Yes! Click the emoji button next to the input field to open the emoji picker.</p></div>;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="space-y-1.5 bg-muted/50 p-3.5 rounded-2xl"><h4 className="font-medium text-[15px]">How do I sort my todos?</h4><p className="text-sm text-muted-foreground">Click the list icon on the left side of the input field to access sorting options.</p></div>;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  let t11;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div>{t7}<div className="space-y-4">{t8}{t9}<div className="space-y-1.5 bg-muted/50 p-3.5 rounded-2xl"><h4 className="font-medium text-[15px]">How do I set a due date?</h4><p className="text-sm text-muted-foreground">Click on the date at the top of the screen to open the calendar, then select your desired date.</p></div></div></div>;
    t11 = <h3 className="text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-3">{"Voice & AI"}</h3>;
    $[9] = t10;
    $[10] = t11;
  } else {
    t10 = $[9];
    t11 = $[10];
  }
  let t12;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="space-y-1.5 bg-muted/50 p-3.5 rounded-2xl"><h4 className="font-medium text-[15px]">Can I use voice commands?</h4><p className="text-sm text-muted-foreground">Yes! Try saying "Add buy groceries" or "Complete buy milk" to automatically perform those actions.</p></div>;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  let t13;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="space-y-1.5 bg-muted/50 p-3.5 rounded-2xl"><h4 className="font-medium text-[15px]">What voice commands are supported?</h4><p className="text-sm text-muted-foreground">You can say "Add [task]", "Complete [task]", "Delete [task]", "Edit [task] to [new task]", "Sort by [criterion]", and "Clear [all/completed/incomplete]".</p></div>;
    $[12] = t13;
  } else {
    t13 = $[12];
  }
  let t14;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="space-y-6 p-2">{t6}{t10}<div>{t11}<div className="space-y-4">{t12}{t13}<div className="space-y-1.5 bg-muted/50 p-3.5 rounded-2xl"><h4 className="font-medium text-[15px]">Why isn't my microphone working?</h4><p className="text-sm text-muted-foreground">Make sure you've granted microphone permissions to the app in your browser settings. If the icon is red, it means permission was denied.</p></div></div></div></div>;
    $[13] = t14;
  } else {
    t14 = $[13];
  }
  return t14;
}